
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150.25 150.25"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"75.12","cy":"75.12","r":"75.12","fill":"#3b7cf7"}}),_c('path',{attrs:{"d":"M27,89.32H41.24v19h-8A6.27,6.27,0,0,1,27,102Zm0,0","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"d":"M116.68,77.94V69.29C116.68,47,98.63,28.2,76.37,28.2S36.05,47,36.05,69.29v20H29.79v-20m86.89,8.65M34.91,47.87C42.63,32.61,58.3,21.93,76.37,21.93c25.72,0,46.57,21.64,46.57,47.36v20h-6.26m6.26,0","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"d":"M118.15,108.3h-8v-19h14.29V102a6.26,6.26,0,0,1-6.26,6.26Zm0,0","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"d":"M45.94,81.73H56.37A8.61,8.61,0,0,1,65,90.34v16.94a8.61,8.61,0,0,1-8.61,8.61H45.94a4.7,4.7,0,0,1-4.7-4.7V86.43a4.7,4.7,0,0,1,4.7-4.7Zm0,0","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"d":"M86.38,107.28V90.34A8.61,8.61,0,0,1,95,81.73h10.44a4.7,4.7,0,0,1,4.69,4.7v24.76a4.7,4.7,0,0,1-4.69,4.7H95a8.69,8.69,0,0,1-3.08-.57m13.52.57","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
          )
        }
      }
    